import type { KaraokeData, KaraokeLine } from '../../types/karaoke';

/**
 * Project a live `KaraokeLine` to its persisted clip shape: drop the full
 * `transcriptTokens` and the computed `allHiddenTranscriptTokenIds` /
 * `transcriptStartTime` / `transcriptEndTime` — the four fields the
 * `KaraokeData` clip type `Omit`s — keep the `...rest`, and record token
 * identity as `transcriptTokenIds`. Tokens are re-resolved from the live
 * transcript on load, so ids are the sole persisted token representation.
 *
 * Shared by every karaoke serializer (`KaraokeStore.getKaraokeData`,
 * `ClipVideoCreatorAdapter`, `VideoEditor.exportVideoSources`) so the persisted
 * shape can't drift between save paths (PLAT-10787). The four omitted names
 * must stay in sync with the type's `Omit<…>`.
 */
export function toPersistedKaraokeClip(
  line: KaraokeLine,
): KaraokeData['clips'][number] {
  const {
    transcriptTokens,
    allHiddenTranscriptTokenIds,
    transcriptStartTime,
    transcriptEndTime,
    ...rest
  } = line;
  return {
    ...rest,
    transcriptTokenIds: transcriptTokens.map(token => token.id),
  };
}
